module.exports = __webpack_public_path__ + "img/arrow-right-green.5d757c2a.svg";